/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */
import type { Cuid } from './cuid'

export type VideoSurveySubmissionInputAnswersItem = {
  /** @nullable */
  leadValue?: string | null
  /** @nullable */
  freeText?: string | null
  optionIds?: string[]
  questionId: Cuid
}
